import axios from 'axios'
import { getBFFUrl, getToken } from './requests'

export const getTokenizedURL = async () => {
  const token = await getToken()

  const res = await axios.get(`${getBFFUrl()}/tokenize`, {
    headers: {
      'x-access-token': token,
      'operator': 'Fertagus',
    },
    params: {
      redirect: 'window.location.href',
      operator: 'FERTAGUS',
    },
  })

  return res.data.data.gtwUrl
}

export const getCards = async () => {
  const token = await getToken()

  const res = await axios.get(`${getBFFUrl()}/cards`, {
    params: {
      operator: 'FERTAGUS',
    },
    headers: {
      'x-access-token': token,
      'operator': 'Fertagus',
    },
  })

  return res.data.data.cards
}

export const deleteCard = async cardToken => {
  const token = await getToken()

  await axios.delete(`${getBFFUrl()}/cards?cardToken=${cardToken}`, {
    params: {
      operator: 'FERTAGUS',
    },
    headers: {
      'x-access-token': token,
      'operator': 'Fertagus',
    },
  })

  return true
}

export const activatePickCard = async cardToken => {
  const token = await getToken()

  const res = await axios.get(`${getBFFUrl()}/activatePickCard?cardToken=${cardToken}`, {
    params: {
      operator: 'FERTAGUS',
    },
    headers: {
      'x-access-token': token,
      'operator': 'Fertagus',
    },
  })

  return res.data
}

export const addMoneyToPickCard = async (cardToken, data) => {
  const token = await getToken()

  console.log(cardToken, data)

  const res = await axios.post(
    `${getBFFUrl()}/addMoneyToPickCard`,
    {
      cardToken,
      amount: data.amount,
      date: data.date,
      bank: data.bank,
      cardNumber: data.cardNumber,
      operator: 'FERTAGUS',
    },
    {
      headers: {
        'x-access-token': token,
        'operator': 'Fertagus',
      },
    }
  )

  return res.data
}
